<template>
    <transition name="modal-fade">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop>
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>

                <div class="col-12 ">
                    <div class="top" style="height:60px;"> </div>

                    <h5 style="font-weight:800;">{{title}}</h5>

                    <small v-if="contractObj!=null">
                        {{contractObj.Data.ScopeOfServices?.length > 30? contractObj.Data.ScopeOfServices.substring(0, 30) + '...': contractObj.Data.ScopeOfServices}} - {{contractObj.CreatedDate}}
                    </small>

                    <div class="box">
                        <div class="upload-area"
                             @dragover.prevent
                             @drop.prevent="handleDrop"
                             @dragenter="isDragging = true"
                             @dragleave="isDragging = false">
                            <input type="file" ref="myfile" accept="image/*,.pdf" @change="onFileChange" />
                            <p v-if="!isDragging && !contract" class="upload-message">Drag & Drop the signed agreement here or</p>
                            <p v-if="isDragging" class="drag-message">Drop the signed agreement to upload</p>
                            <button @click="$refs.myfile.click()" class="browse-button">Browse files</button>
                        </div>


                    </div>
                    <small>{{note}}</small>
                  
                    <br><br>
                </div>
            </div>
        
        </div>
    </transition>

</template>

<script>
    
    export default {
         
        data() {
            return {
                contract: null,
                contractObj: null,
                isDragging: false,
                title: 'Upload signed agreement from your Client',
                note: 'Note: Your Client must scan either a PDF or Image type file.'
            }
        },
        methods: {

            setContractId(contract) {
                this.contractObj = contract;
                if (contract.Type == 0) {
                    this.title = "Upload signed agreement from your Sub-Contractor";
                    this.note = 'Note: Your Sub-Contractor must scan either a PDF or Image type file.';
                }
                console.log("setContract", this.contractObj);
            },

            onFileChange(event) {
                const file = event.target.files[0];

                console.log("onFileChange file", file);
                if (file) {
                    this.contract = file;

                    this.upload(true, file);
                }
            },
            handleDrop(event) {
                this.isDragging = false;
                const file = event.dataTransfer.files[0];

                console.log("handleDrop file", file);
                if (file) {
                    this.contract = file;

                    this.upload(true, file);
                }
            },
            upload(isConfirmed, file) {


                let postdata = new FormData();
                postdata.append('file', file);
                postdata.append('id', this.contractObj.Id);

                // Debugging FormData
                postdata.forEach((value, key) => {
                    console.log(`${key}: ${value}`);
                });

                this.$loader.show(null, 30);
                this.$emit('close-modal');
                this.$http.request("post", `/api/app/barcode/ScanDocuments`, postdata).then((res) => {

                    console.log("uploadsigned", res);

                    if (res?.Type == 200) {
                        this.contract = res.Data;

                        let obj = res.Data;
                        this.$refs.myfile.value = null;

                        this.$ui.alert(this, "Success", "Contract successfully uploaded!", "success").then(() => {
                            //this.$router.push('/MyProjects');
                           
                            this.$emit('refresh');
                        });

                    } else {
                        this.$ui.alert(this, "Failure", res.Content, "error");

                    }
                }).finally(() => {
                    this.$loader.hide();
                });




            }
        }
    }
</script>

<style scoped>

    .modal-overlay {
        z-index: 999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
    }

    .modal-content {
        background-color: white;
        height: fit-content;
        width: 800px;
        max-width: 90vh;
        max-height: 90vh;
        margin-top: 5%;
        padding: 0px 24px;
        border-radius: 20px;
        overflow: auto;
    } 

    .box {
        padding: 20px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        max-width: 600px;
        margin: 32px auto;
    }

    .upload-area {
        border: 2px dashed #ccc;
        border-radius: 10px;
        padding: 40px;
        text-align: center;
        cursor: pointer;
        background-color: #f8f8f8;
    }

        .upload-area input[type="file"] {
            display: none;
        }

    .upload-message,
    .drag-message {
        font-size: 16px;
        margin-bottom: 10px;
        color: #666;
    }

    .drag-message {
        color: #009688;
    }

    .browse-button {
        background-color: #28a745;
        color: #fff;
        padding: 10px 20px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

        .browse-button:hover {
            background-color: #218838;
        }

    .file-preview {
        margin-top: 20px;
    }

    .file-name {
        font-size: 14px;
        color: #333;
        margin-bottom: 10px;
    }

    .btn-positive {
        background-color: #28a745;
        color: #fff;
        padding: 10px 20px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

        .btn-positive:hover {
            background-color: #218838;
        }
</style>
